<template>
	<div class="cart color-black">
		<div class="container">
			<div class="row">
				<div class="col-12 pl-0 pr-0 pt-2">
					<div class="col-12 p-0 p-md-3 mt-4 background-white cus-box-shadow rounded shipping-method">
						<div class="col-12 d-md-flex pl-0 pr-0 pb-3 pl-lg-3 pr-lg-3">
							<div class="col-12 col-md-6 pt-2 pt-md-0">
								<div class="color-mila font-size-18 font-size-sm-12 font-weight-bold f-lato">{{cartOne.stockist_code}}</div>
								<div class="color-black font-size-14 font-size-sm-11 pt-1">{{ cartOne.stockist_name }}</div>
							</div>
							<div class="col-12 col-md-6 text-md-right">
								<div class="col-12 mt-2 mt-md-3 pt-1 pr-0 pl-0 pl-md-3">
									<span v-if="cartOne.stockist_origin_city_name && cartOne.stockist_origin_province_name" class="background-gray-dark no-box-shadow rounded font-size-12 font-size-sm-10 color-white p-2 pl-3 pr-3" id="lokasi-stockist">
										<font-awesome-icon :icon="['fas', 'map-marker-alt']" class="mr-2"/>
										{{cartOne.stockist_origin_city_name}}, {{cartOne.stockist_origin_province_name}}
									</span>
								</div>
							</div>
						</div>
						<div class="col-12 d-block d-md-none"><div class="col-12 border-bottom"></div></div>
						<div class="col-12 pl-0 pr-0 overflow-auto">
							<div class="col-12 pl-md-0 pr-md-0 pl-lg-3 pr-lg-3">
								<div class="col-12 d-none d-md-block"><div class="col-12 border-bottom"></div></div>
								<div class="col-12 d-flex text-center font-weight-bold font-size-sm-10">
									<div class="col-8 col-md-4 pt-3 pb-3">Item</div>
									<div class="col-5 col-md-3 pt-3 pb-3 text-right">Harga (Rp)</div>
									<div class="col-5 col-md-2 pt-3 pb-3 text-center">Jumlah</div>
									<div class="col-5 col-md-3 pt-3 pb-3 text-right pr-md-0">Total (Rp)</div>
								</div>
								<div class="col-12 d-none d-md-block"><div class="col-12 border-bottom"></div></div>
							</div>
							<div class="col-12 pt-2 text-center pl-md-0 pr-md-0 pl-lg-3 pr-lg-3" v-for="(product, index) in cartOne.products" :key="index">
								<div class="col-12 d-flex pb-2 font-size-sm-10">
									<div class="col-8 col-md-4 d-flex pl-0">
										<div class="col-4 col-md-3 pl-0 mt-auto mb-auto"><img class="img-fluid rounded" :src="product.product_image_filename" alt=""></div>
										<div class="col-8 col-md-9 m-auto pl-0 pr-0 text-left">{{ product.product_name }}</div>
									</div>
									<div class="col-5 col-md-3 mt-auto mb-auto f-lato text-right">{{ product.product_price | toNumber }}</div>
									<div class="col-5 col-md-2 mt-auto mb-auto f-lato text-center">{{ product.quantity}} {{ product.product_unit }}</div>
									<div class="col-5 col-md-3 pr-md-0 mt-auto mb-auto f-lato text-right">{{ product.product_price * product.quantity | toNumber }}</div>
								</div>
							</div>
							<div class="col-12 pt-2 text-center" v-if="!isAuth && registerItem.title">
								<div class="col-12 d-flex pb-2 font-size-sm-10">
									<div class="col-8 col-md-4 d-flex pl-0">
										<div class="col-4 col-md-3 pl-0"><img class="img-fluid rounded" :src="registerItem.image" alt=""></div>
										<div class="col-8 col-md-9 m-auto pl-0 pr-0 text-left">{{ registerItem.title }}</div>
									</div>
									<div class="col-5 col-md-3 m-auto f-lato text-right">{{ registerItem.price | toNumber }}</div>
									<div class="col-5 col-md-2 mt-auto mb-auto pl-0 pr-0 pl-md-3 pr-md-3 f-lato">{{ registerItem.quantity }} {{ registerItem.unit }}</div>
									<div class="col-5 col-md-3 m-auto pr-md-0 f-lato text-right">{{ registerItem.price_total | toNumber }}</div>
								</div>
							</div>
						</div>
						<div class="col-12">
							<div class="col-12 d-none d-lg-block"><div class="col-12 border-bottom"></div></div>
							<div class="col-12 pt-2 d-block d-lg-none border-bottom"></div>
						</div>
						<div class="col-12 d-md-flex pt-4 pl-0 pr-0 pl-lg-3 pr-lg-3">
							<div class="col-12 col-md-3 col-lg-5 color-black">
								<div class="font-size-14 font-size-sm-12">Total Berat</div>
								<div class="font-size-20 font-size-sm-14 f-lato">{{ weightTotal | toKg }}</div>
							</div>
							<div class="col-12 col-md-9 col-lg-7 text-right">
								<div class="col-12 pt-3 pl-0 pr-0">
									<button class="col-12 col-md-3 btn btn-outline-danger rounded pt-2 pb-2 mr-3" @click="step_down()">
										<i class="fas fa-arrow-left mr-2"></i>
										<span class="font-size-12 font-size-sm-11">Kembali</span>
									</button>
									<div class="col-12 btn-group col-md-7 pl-0 pl-md-2 pr-0 pt-3 pb-3 pt-md-0 pb-md-0">
										<button type="button" class="col-12 btn background-button-template dropdown-toggle color-white pt-2 pb-2 pl-4 pr-4 box-purple d-flex justify-content-between" data-toggle="dropdown">
											<span class="font-size-12 font-size-sm-11">{{ shipMethod.name }}</span>
											<i class="fas fa-chevron-down mt-1"></i>
										</button>
										<div class="dropdown-menu" v-if="stockistOne.stockist_origin_subdistrict_id && stockistOne.stockist_courier_arr.length > 0">
											<a class="dropdown-item color-black d-flex" v-for="(shipping, index) in listShipMethod" :key="index" href="javascript:;" @click="changeShipping(shipping.ship, shipping.id)" >
												<div class="col-2 pl-0 pr-0"><img class="img-fluid img-ship pr-3" :src="shipping.img" alt=""></div>
												<div class="font-size-12 font-size-sm-11">{{shipping.ship}}</div>
											</a>
										</div>
										<div class="dropdown-menu" v-else>
											<a class="dropdown-item color-black d-flex" href="javascript:;">
												<div class="col-2 pl-0 pr-0"><img class="img-fluid img-ship pr-3" src="/assets/icon/ic_stop.png" alt=""></div>
												<div>Pengiriman tidak Tersedia</div>
											</a>
											<!--
											<a class="dropdown-item color-black d-flex" href="javascript:;" @click="changeShipping('Diambil ke Mobile Counter', 0)" >
												<div class="col-2 pl-0 pr-0"><img class="img-fluid img-ship pr-3" src="/assets/icon/pick-up.svg" alt=""></div>
												<div>Diambil ke Mobile Counter</div>
											</a>
											-->
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 pt-2 pb-2 mt-4" v-if="shipMethod.code === 0">
						<div class="col-12 pl-0 pr-0 font-size-sm-9">
							<div class="col-12 background-white rounded cus-box-shadow pt-4 pb-4 d-md-flex flex-wrap active-address pl-0 pr-0 pl-lg-3 pr-lg-3">
								<div class="col-12 col-lg-9 p-0 pl-md-2 pr-md-2">
									<div class="col-12 pl-0 pr-0 d-md-flex">
										<div class="col-12 col-md-7 col-lg-6 pr-0 d-flex">
											<div class="col-1 p-0"><i class="fas fa-user mr-1 color-mila mt-2"></i></div>
											<div class="col-11">
												<div class="col-12 p-0 font-bold font-size-13 font-size-sm-12 color-mila">Nama Mobile Counter</div>
												<div class="col-12 p-0 color-black">{{stockistOne.stockist_name}}</div>
											</div>
										</div>
										<div class="col-12 col-md-5 col-lg-6 pr-0 p-md-0 d-flex pt-2">
											<div class="col-1 p-0"><i class="fas fa-phone mr-1 color-mila mt-2"></i></div>
											<div class="col-11">
												<div class="col-12 p-0 font-bold font-size-13 font-size-sm-12 color-mila">Nomor Handphone</div>
												<div class="col-12 p-0 color-black f-lato">{{stockistOne.stockist_mobilephone}}</div>
											</div>
										</div>
									</div>
									<div class="col-12 pl-0 pr-0 pt-2 pt-md-4 d-md-flex">
										<div class="col-12 col-md-7 col-lg-6 pr-0 d-flex">
											<div class="col-1 p-0"><i class="fas fa-map-marker-alt mr-1 color-mila mt-2"></i></div>
											<div class="col-11">
												<div class="col-11 p-0 font-bold font-size-13 font-size-sm-12 color-mila">Alamat Pengambilan</div>
												<div class="col-11 p-0 color-black">{{stockistOne.stockist_origin_address}}<span v-if="stockistOne.stockist_origin_subdistrict_name">, {{stockistOne.stockist_origin_subdistrict_name}},</span> <span v-if="stockistOne.stockist_origin_city_name">{{stockistOne.stockist_origin_city_type}} {{stockistOne.stockist_origin_city_name}},</span> <span v-if="stockistOne.stockist_origin_province_name">{{stockistOne.stockist_origin_province_name}}</span></div>
											</div>
										</div>
										<div class="col-10 col-md-5 col-lg-6 pl-md-0 pr-md-0-0 pt-3 pt-md-2">
											<div class="col-12 p-0">
												<div class="color-gray-2 icon-calender"><i class="fas fa-calendar-alt"></i></div>
												<datepicker v-model="pickup.date" @closed="()=>{new Date(pickup.date); pickup_error = false;}" bootstrap-styling :format="customFormatter" :language="indo" :full-month-name="true" :disabled-dates="disabledDates" wrapper-class="col-lg-8 col-md-10 col-12 pr-0 pl-0" input-class="no-box-shadow font-size-sm-10 box-purple f-lato background-white pl-5" placeholder="Tanggal Pengambilan">
												</datepicker>
												<div v-if="pickup_error" class="color-red font-size-10 pt-1 pl-3 pl-md-0">Pilih tanggal pengambilan terlebih dulu</div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-12 col-md-5 col-lg-3 m-auto pt-4 pt-lg-0">
									<div class="col-12 pl-0 pr-0 pl-md-3 pr-md-3 text-md-center">
										<div>Total Pembayaran</div>
										<div class="font-size-20 font-size-sm-14 f-lato">Rp {{priceTotal | toNumber}}</div>
										<button @click="nextPickup" class="col-12 mt-2 btn background-button-template color-white pt-2 pb-2 box-purple">
											<i class="fas fa-wallet mr-3"></i>
											<span class="font-size-12 font-size-sm-11">Bayar Sekarang</span>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 pt-2 pb-2 mt-4 d-md-flex flex-wrap" v-else-if="shipMethod.code === 1">
						<div class="col-12 col-lg-7 pl-0 pr-0 pr-lg-3 font-size-sm-9">
							<div class="col-12 background-white rounded cus-box-shadow address pl-0 pr-0 pl-md-3 pr-md-3 active-address" v-if="!isAuth">
								<div class="col-12 p-0 pl-md-2 pr-md-2" v-if="!courier.status">
									<div class="col-12 text-center color-mila font-size-16 font-size-sm-12 font-bold pt-2">
										Alamat Pengiriman
									</div>
									<div class="col-12 p-3">
										<div class="col-6 col-md- m-auto">
											<img class="img-fluid mt-2" src="/assets/icon/ilus-alamat-pengiriman.svg">
										</div>
										<div class="col-12 text-center pt-4 pb-2">
											<button class="btn background-gray-2 color-white box-purple" @click="$refs.modalAlamatPublic.modalShow()">
												<i class="fas fa-plus font-size-10 mr-3"></i><span class="font-size-11">Isi Alamat</span>
											</button>
										</div>
									</div>
								</div>
								<div class="col-12 pl-0 pr-0 pt-3 pl-md-2 pr-md-2 pb-2" v-if="courier.status">
									<div class="col-12 text-center color-mila font-size-16 font-size-sm-12 font-bold">
										Alamat Pengiriman
									</div>
									<div class="col-12 pl-0 pr-0 d-md-flex pt-2 pt-md-3">
										<div class="col-12 col-md-6 pr-0 d-flex">
											<div class="col-1 p-0"><i class="fas fa-user mr-1 color-mila mt-2"></i></div>
											<div class="col-11">
												<div class="col-12 p-0 font-bold font-size-13 font-size-sm-11 color-mila">Penerima</div>
												<div class="col-12 p-0 color-black f-lato">{{courier.name}}</div>
											</div>
										</div>
										<div class="col-12 col-md-6 pt-2 pt-md-0 pr-0 d-flex">
											<div class="col-1 p-0"><i class="fas fa-phone mr-1 color-mila mt-2"></i></div>
											<div class="col-11">
												<div class="col-12 p-0 font-bold font-size-13 font-size-sm-11 color-mila">Nomor Handphone</div>
												<div class="col-12 p-0 color-black f-lato">{{courier.phone}}</div>
											</div>
										</div>
									</div>
									<div class="col-12 pl-0 pr-0 pt-2 pt-md-3 d-flex">
										<div class="col-12 pr-0 d-flex">
											<div class="col-1 p-0"><i class="fas fa-map-marker-alt mr-1 color-mila mt-2"></i></div>
											<div class="col-11 pl-md-0 ml-md-n2">
												<div class="col-12 p-0 font-bold font-size-13 font-size-sm-11 color-mila">Alamat</div>
												<div class="col-12 p-0 color-black f-lato">{{courier.detail}}, {{courier.district.subdistrict_name}}, {{courier.district.type}}, {{courier.district.city_name}}, {{courier.district.province}}</div>
											</div>
										</div>
									</div>
									<div class="col-12">
										<div class="col-12 text-center pt-4 pb-2">
											<button class="btn background-gray-2 color-white box-purple" @click="$refs.modalAlamatPublic.modalShow()">
												<div class="font-size-sm-10">
													<i class="fas fa-edit font-size-10 mr-3"></i><span class="font-size-11">Edit Alamat</span>
												</div>
											</button>
										</div>
									</div>
								</div>
							</div>
							<div :class="listAdress.length === 0 ? ' active-address' : '' " class="col-12 background-white rounded cus-box-shadow pl-0 pr-0 pl-md-3 pr-md-3 address" v-if="isAuth">
								<div class="col-12 p-0 pl-md-2 pr-md-2" v-if="listAdress == 'error'">
									<div class="col-12 p-0 pl-md-2 pr-md-2">
										<div class="col-12 text-center color-mila font-size-16 font-size-sm-12 font-bold pt-2">
											Alamat Pengiriman
										</div>
										<div class="col-12 p-3">
											<div class="col-6 col-md-6 m-auto">
												<img class="img-fluid mt-2" src="/assets/icon/ilus-alamat-pengiriman.svg">
											</div>
											<div class="col-12 text-center pt-4 pb-2">
												<button class="btn background-gray-2 color-white box-purple" @click="addAlamat">
													<i class="fas fa-plus font-size-10 mr-3"></i><span class="font-size-11">Tambah Alamat</span>
												</button>
											</div>
										</div>
									</div>
								</div>
								<div class="col-12 p-3 p-lg-4 address" v-if="listAdress.length > 0 && Array.isArray(listAdress)">
									<div @click="chooseAddress(address.address_id)" v-for="(address, index) in addressMember" :key="index" class="col-12 background-white rounded cus-box-shadow pt-2 pb-2 mb-4" :class=" address.address_is_default == 1 ? 'active-address' : ''">
										<div class="col-12 p-0 pl-md-2 pr-md-2 pb-2">
											<div class="col-12 pl-0 pr-0 pt-1 d-md-flex">
												<div class="col-12 col-md-6 pr-0 d-flex">
													<div class="col-1 p-0"><i class="fas fa-user mr-1 color-mila mt-2"></i></div>
													<div class="col-11">
														<div class="col-12 p-0 font-bold font-size-13 font-size-sm-11 color-mila">Penerima</div>
														<div class="col-12 p-0 color-black">{{ address.address_receipt_name }}</div>
													</div>
												</div>
												<div class="col-12 col-md-6 pr-0 p-md-0 d-flex pt-2">
													<div class="col-1 p-0 text-center"><i class="fas fa-phone mr-1 color-mila mt-2"></i></div>
													<div class="col-11">
														<div class="col-11 p-0 font-bold font-size-13 font-size-sm-11 color-mila">Nomor Handphone</div>
														<div class="col-11 p-0 color-black f-lato">{{ address.address_phonenumber }}</div>
													</div>
												</div>
											</div>
											<div class="col-12 pl-0 pr-0 pt-2 pt-md-4 d-flex">
												<div class="col-12 pr-0 d-flex">
													<div class="col-1 p-0"><i class="fas fa-map-marker-alt mr-1 color-mila mt-2"></i></div>
													<div class="col-11 pl-md-0 ml-md-n2">
														<div class="col-12 p-0 font-bold font-size-13 font-size-sm-12 color-mila">Alamat Pengiriman</div>
														<div class="col-12 p-0 color-black f-lato">{{ address.address_name }} - {{ address.address_detail }}, {{ address.subdistrict_name }}, {{ address.type }} {{ address.city_name }}, {{ address.province }}</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-12 text-center">
										<div class="" v-show="(showMoreAddress || listAdress.length == 1 ) && Array.isArray(listAdress)">
											<button class="btn background-gray-2 color-white box-purple" @click="addAlamat"><i class="fas fa-plus font-size-10 mr-3"></i><span class="font-size-11">Tambah Alamat</span></button>
										</div>
										<div class="" v-show="(!showMoreAddress && listAdress.length > 1) && Array.isArray(listAdress)">
											<button class="btn background-gray-2 color-white box-purple" @click="()=>showMoreAddress = !showMoreAddress"><i class="fas fa-sync font-size-10 mr-3"></i><span class="font-size-11">Alamat Lainnya</span></button>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-12 col-lg-5 pr-0 pl-0 pl-lg-3 mt-4 mt-lg-0 pt-2 pt-lg-0">
							<div class="col-12 p-0 background-white cus-box-shadow rounded" v-if="Object.keys(courServiceList).length == 0">
								<div class="col-12 background-purple color-white text-center rounded-top pt-2 pb-2">
									<div class="font-size-16 font-size-sm-14">Pilih Jasa Pengiriman</div>
								</div>
								<div class="col-12 pt-2 pb-2 text-center">
									<div class="col-12 p-0">
										<label class="product-name color-black mb-0 pl-0" v-for="(index) in 4" :key="index">
											<vcl :width='300' :height='39' class="background-white border-top">
												<rect x="18" y="15" rx="8" ry="8" width="10" height="10" />
												<rect x="45" y="9" rx="2" ry="2" width="30" height="20" />
												<rect x="100" y="9" rx="2" ry="2" width="40" height="10" />
												<rect x="100" y="22" rx="2" ry="2" width="80" height="10" />
												<rect x="220" y="22" rx="2" ry="2" width="60" height="10" />
											</vcl>
										</label>
									</div>
								</div>
							</div>
							<div class="col-12 p-0 background-white cus-box-shadow rounded address" v-else-if="courServiceList == 'error'">
								<div class="col-12 background-purple color-white text-center rounded-top pt-2 pb-2">
									<div class="font-size-16 font-size-sm-14">Pilih Jasa Pengiriman</div>
								</div>
								<div class="col-12 pt-2 pb-4">
									<div class="col-4 m-auto py-4">
										<img class="img-fluid" src="/assets/icon/daftar-jasa-logistik-null.svg">
									</div>
								</div>
							</div>
							<div class="col-12 p-0 background-white cus-box-shadow rounded" v-else>
								<div class="col-12 background-purple color-white text-center rounded-top pt-2 pb-2">
									<div class="font-size-16 font-size-sm-14">Pilih Jasa Pengiriman</div>
								</div>
								<div class="col-12 pt-2 pb-2 text-center">
									<div class="col-12 p-0 pl-md-3 pr-md-3 p-lg-0 logistic">
										<label class="product-name color-black mb-0 pl-0" v-for="(courier, index) in courServiceList" :key="index" @click="changeCourier(courier)">
											<div class="background-white border-top z-index-1 pb-0">
												<h2 class="mb-0 d-flex">
													<input type="radio" name="radio" :value="courier" v-model="courSelected">
													<span class="checkmark mt-n1 mt-md-1 ml-3"></span>
													<div class="col-3 offset-1"><img class="width-90 img-fluid pt-0" :src="'assets/kurir/'+courier.code.toLowerCase()+'.png'" alt=""></div>
													<div class="col-8 font-size-10 font-size-sm-8 color-black pl-0 m-auto text-left">
														<div>{{ courier.service }}</div>
														<div class="col-12 p-0 d-flex justify-content-between">
															<div class="col-6 p-0">Estimasi {{courier.etd}}</div>
															<div class="col-6 p-0 text-right">Rp {{ courier.cost | toNumber }}</div>
														</div>
													</div>
												</h2>
											</div>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 mt-4 background-white cus-box-shadow rounded-top" v-show="isLogistic && shipMethod.code === 1">
						<div class="col-12 background-purple color-white text-center rounded-top pt-2 pb-2">
							<div class="font-size-16 font-size-sm-14 pay-detail">Detail Pembayaran</div>
						</div>
						<div class="col-12 pt-4 pb-3">
							<div class="col-12 pl-0 pl-lg-3 pr-0 pr-lg-3">
								<div class="col-12 pl-0 pl-md-3 pr-0 pr-md-3 overflow-sm-auto" v-if="courSelected">
									<table class="table table-striped font-size-sm-10 width-sm-150pct">
										<tbody>
											<tr>
												<td colspan="2">Total Harga Produk</td>
												<td colspan="2" class="text-right f-lato">Rp {{priceTotal | toNumber}}</td>
											</tr>
											<tr>
												<td>Ongkos Kirim</td>
												<td class="text-center f-lato">{{ weightTotal | toKg }}</td>
												<td class="text-center f-lato">Rp {{ courSelected.cost / weightCour | toNumber }} / kg</td>
												<td class="text-right f-lato">Rp {{ courSelected.cost | toNumber }}</td>
											</tr>
											<tr>
												<th colspan="2" class="font-size-14 font-size-sm-12">Total Pembayaran</th>
												<th colspan="2" class="font-size-14 font-size-sm-12 text-right f-lato">Rp {{priceTotal + courSelected.cost | toNumber}}</th>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
						<div class="col-12 text-center pb-4">
							<button @click="step_up" class="col-12 col-md-3 btn background-button-template color-white pt-2 pb-2 box-purple">
								<i class="fas fa-wallet mr-3"></i>
								<span class="font-size-12 font-size-sm-11">Bayar Sekarang</span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<VModal ref="modalAddAlamat" >
			<template v-slot:header>
				<div>
					<div class="modal-header justify-content-center">
						<h5 class="modal-title">Tambah Data Alamat</h5>
						<button @click="$refs.modalAddAlamat.modalHide()" class="btn btn-no-box"> <img src="../../assets/modal_x.svg" class="close-modal mt-n1"></button>
					</div>
				</div>
			</template>
			<template v-slot:body>
				<div class="col-12 text-center pt-3 pb-3">
					<form class="mt-2">
						<div class="form-inline">
							<input class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 box-purple" @focus="() => alert.label=''" type="text" placeholder="Label Alamat, Contoh: Rumah" v-model="insert.name" />
							<Alert v-if="alert.label" class="col-12 offset-md-2 col-md-8 font-size-sm-9 text-left pl-0" empty :content="alert.label"/>
						</div>
						<div class="form-inline mt-3">
							<input class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 box-purple" @focus="() => alert.name=''" type="text" placeholder="Nama Penerima" v-model="insert.receipt_name" />
							<Alert v-if="alert.name" class="col-12 offset-md-2 col-md-8 font-size-sm-9 text-left pl-0" empty :content="alert.name"/>
						</div>
						<div class="form-inline mt-3">
							<input @keypress="onlyNumber" maxlength="15" class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 f-lato box-purple" @focus="() => alert.phonenumber=''" type="text" placeholder="Nomor Handphone" v-model="insert.phonenumber" />
							<Alert v-if="alert.phonenumber" class="col-12 offset-md-2 col-md-8 font-size-sm-9 text-left pl-0" empty :content="alert.phonenumber"/>
						</div>
						<div class="form-inline mt-3">
							<v-select label="province" class="col-12 offset-md-2 col-md-8 font-size-sm-10 pl-0 pr-0" :reduce="provinces => provinces.province_id" :options="provinces" v-model="insert.province_id" placeholder="Pilih Provinsi" @input="changeProvince">
								<template #selected-option="{ province }">
									<div style="display: flex; align-items: baseline;">
										<span>Provinsi</span>
										<span style="margin-left: .4rem;">{{ province }}</span>
									</div>
								</template>
								<template v-slot:option="option">
									Provinsi {{ option.province }}
								</template>
								<template v-slot:no-options="{ search, searching }">
									<template v-if="searching">
										Tidak ada kata yang cocok untuk <em>{{ search }}</em>.
									</template>
									<em style="opacity: 0.5;" v-else>Ketik untuk mencari Provinsi</em>
								</template>
							</v-select>
							<!-- <select class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 box-purple" @focus="() => alert.prov=''" name="province_id" v-model="insert.province_id" @change="changeProv(insert.province_id)">
								<option value="">Provinsi</option>
								<option v-for="(province, index) in provinces" :key="index" :value="province.province_id">Provinsi {{province.province}}</option>
							</select> -->
							<Alert v-if="alert.city" class="col-12 offset-md-2 col-md-8 font-size-sm-9 text-left pl-0" empty :content="alert.prov"/>
						</div>
						<div class="form-inline mt-3">
							<v-select label="city_name" class="col-12 offset-md-2 col-md-8 font-size-sm-10 pl-0 pr-0" :reduce="city => city.city_id" :options="city" v-model="insert.city_id" placeholder="Pilih Kabupaten/Kota" @input="changeCities">
								<template #selected-option="{ type, city_name }">
									<div style="display: flex; align-items: baseline;">
										<span>{{ type }}</span>
										<span style="margin-left: .4rem;">{{ city_name }}</span>
									</div>
								</template>
								<template v-slot:option="option">
									{{ option.type }} {{ option.city_name }}
								</template>
								<template v-slot:no-options="{ search, searching }">
									<template v-if="searching">
										Tidak ada kata yang cocok untuk <em>{{ search }}</em>.
									</template>
									<em style="opacity: 0.5;" v-else>Silahkan memilih Provinsi terlebih dahulu</em>
								</template>
							</v-select>
							<!-- <select class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 box-purple" @focus="() => alert.city=''" name="city_id" v-model="insert.city_id" @change="changeCity(insert.city_id)">
								<option value="">Kota / Kabupaten</option>
								<option v-for="(city, index) in city" :key="index" :value="city.city_id">{{city.type}} {{city.city_name}}</option>
							</select> -->
							<Alert v-if="alert.city" class="col-12 offset-md-2 col-md-8 font-size-sm-9 text-left pl-0" empty :content="alert.city"/>
						</div>
						<div class="form-inline mt-3">
							<v-select label="subdistrict_name" class="col-12 offset-md-2 col-md-8 font-size-sm-10 pl-0 pr-0" :options="districts" v-model="insert.district_id" placeholder="Pilih Kecamatan" @input="() => {changeDistrict(); alert.district='';}">
								<template v-slot:no-options="{ search, searching }">
									<template v-if="searching">
										Tidak ada kata yang cocok untuk <em>{{ search }}</em>.
									</template>
									<em style="opacity: 0.5;" v-else>Silahkan memilih Kabupaten/Kota terlebih dahulu</em>
								</template>
							</v-select>
							<!-- <select @keypress="onlyNumber" class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 box-purple" @focus="() => alert.district=''" v-model="insert.district_id" name="district_id" @change="() => insert.zipcode = insert.district_id.postal_code">
								<option value="">Kecamatan</option>
								<option v-for="(district, index) in districts" :key="index" :value="district">{{district.subdistrict_name}}</option>
							</select> -->
							<Alert v-if="alert.district" class="col-12 offset-md-2 col-md-8 font-size-sm-9 text-left pl-0" empty :content="alert.district"/>
						</div>
						<div class="form-inline mt-3">
							<input type="text" maxlength="5" class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 box-purple f-lato" @focus="() => alert.kodepos=''" v-model="insert.zipcode" name="postal_code" placeholder="Kodepos">
							<Alert v-if="alert.kodepos" class="col-12 offset-md-2 col-md-8 font-size-sm-9 text-left pl-0" empty :content="alert.kodepos"/>
						</div>
						<div class="form-inline mt-3 mb-3">
							<textarea class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 box-purple" @focus="() => alert.address=''" v-model="insert.detail" rows="3" placeholder="Alamat Lengkap" ></textarea>
							<Alert v-if="alert.address" class="col-12 offset-md-2 col-md-8 font-size-sm-9 text-left pl-0" empty :content="alert.address"/>
						</div>
					</form>
				</div>
			</template>
			<template v-slot:footer>
				<div class="modal-footer justify-content-center">
					<button @click="simpan()" class="col-10 col-md-3 btn pt-2 pb-2 rounded background-button-template no-box-shadow color-white text-center">
						<i class="fas fa-save font-size-12 mr-3"></i>
						<span class="font-weight-bold text-capitalize">Simpan</span>
					</button>
				</div>
			</template>
		</VModal>

		<VModal ref="modalAlamatPublic" >
			<template v-slot:header>
				<div class="modal-header justify-content-center">
					<h5 class="modal-title">Form Data Alamat</h5>
					<button class="btn btn-no-box"  @click="$refs.modalAlamatPublic.modalHide()"> <img src="../../assets/modal_x.svg" class="close-modal mt-n1"></button>
				</div>
			</template>
			<template v-slot:body>
				<div class="col-12 text-center pt-3 pb-3">
					<form class="mt-2">
						<div class="form-inline">
							<input class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 box-purple" @focus="() => alert.name=''" type="text" placeholder="Nama Penerima" v-model="courier.name" />
							<Alert v-if="alert.name" class="col-12 offset-md-2 col-md-8 font-size-sm-9 text-left pl-0" empty :content="alert.name"/>
						</div>
						<div class="form-inline mt-3">
							<input @keypress="onlyNumber" class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 f-lato box-purple" @focus="() => alert.phonenumber=''" type="text" placeholder="Nomor Handphone" v-model="courier.phone" maxlength="15"/>
							<Alert v-if="alert.phonenumber" class="col-12 offset-md-2 col-md-8 font-size-sm-9 text-left pl-0" empty :content="alert.phonenumber"/>
						</div>
						<div class="form-inline mt-3">
							<v-select label="province" class="col-12 offset-md-2 col-md-8 font-size-sm-10 pl-0 pr-0" :reduce="provinces => provinces.province_id" :options="provinces" v-model="courier.prov" placeholder="Pilih Provinsi" @input="publicChangeProvince(courier.prov)">
								<template #selected-option="{ province }">
									<div style="display: flex; align-items: baseline;">
										<span>Provinsi</span>
										<span style="margin-left: .4rem;">{{ province }}</span>
									</div>
								</template>
								<template v-slot:option="option">
									Provinsi {{ option.province }}
								</template>
								<template v-slot:no-options="{ search, searching }">
									<template v-if="searching">
										Tidak ada kata yang cocok untuk <em>{{ search }}</em>.
									</template>
									<em style="opacity: 0.5;" v-else>Ketik untuk mencari Provinsi</em>
								</template>
							</v-select>
							<!-- <select class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 box-purple" @focus="() => alert.prov=''" name="province_id" v-model="courier.prov" @change="changeProv(courier.prov)">
								<option value="">Provinsi</option>
								<option v-for="(province, index) in provinces" :key="index" :value="province.province_id">Provinsi {{province.province}}</option>
							</select> -->
							<Alert v-if="alert.prov" class="col-12 offset-md-2 col-md-8 font-size-sm-9 text-left pl-0" empty :content="alert.prov"/>
						</div>
						<div class="form-inline mt-3">
							<v-select label="city_name" class="col-12 offset-md-2 col-md-8 font-size-sm-10 pl-0 pr-0" :reduce="city => city.city_id" :options="city" v-model="courier.city" placeholder="Pilih Kabupaten/Kota" @input="publicChangeCity(courier.city)">
								<template #selected-option="{ type, city_name }">
									<div style="display: flex; align-items: baseline;">
										<span>{{ type }}</span>
										<span style="margin-left: .4rem;">{{ city_name }}</span>
									</div>
								</template>
								<template v-slot:option="option">
									{{ option.type }} {{ option.city_name }}
								</template>
								<template v-slot:no-options="{ search, searching }">
									<template v-if="searching">
										Tidak ada kata yang cocok untuk <em>{{ search }}</em>.
									</template>
									<em style="opacity: 0.5;" v-else>Silahkan memilih Provinsi terlebih dahulu</em>
								</template>
							</v-select>
							<!-- <select class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 box-purple" @focus="() => alert.city=''" name="city_id" v-model="courier.city" @change="changeCity(courier.city)">
								<option value="">Kota / Kabupaten</option>
								<option v-for="(city, index) in city" :key="index" :value="city.city_id">{{city.type}} {{city.city_name}}</option>
							</select> -->
							<Alert v-if="alert.city" class="col-12 offset-md-2 col-md-8 font-size-sm-9 text-left pl-0" empty :content="alert.city"/>
						</div>
						<div class="form-inline mt-3">
							<v-select label="subdistrict_name" class="col-12 offset-md-2 col-md-8 font-size-sm-10 pl-0 pr-0" :options="districts" v-model="courier.district" placeholder="Pilih Kecamatan" @input="() => {publicChangeDistrict(); alert.district='';}">
								<template v-slot:no-options="{ search, searching }">
									<template v-if="searching">
										Tidak ada kata yang cocok untuk <em>{{ search }}</em>.
									</template>
									<em style="opacity: 0.5;" v-else>Silahkan memilih Kabupaten/Kota terlebih dahulu</em>
								</template>
							</v-select>
							<!-- <select class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 box-purple" @focus="() => alert.district=''" v-model="courier.district" name="district_id" @change="() => courier.kodepos = courier.district.postal_code">
								<option value="">Kecamatan</option>
								<option v-for="(district, index) in districts" :key="index" :value="district">{{district.subdistrict_name}}</option>
							</select> -->
							<Alert v-if="alert.district" class="col-12 offset-md-2 col-md-8 font-size-sm-9 text-left pl-0" empty :content="alert.district"/>
						</div>
						<div class="form-inline mt-3">
							<input @keypress="onlyNumber" type="text" maxlength="5" class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 box-purple f-lato" @focus="() => alert.kodepos=''" v-model="courier.kodepos" name="postal_code" placeholder="Kodepos">
							<Alert v-if="alert.kodepos" class="col-12 offset-md-2 col-md-8 font-size-sm-9 text-left pl-0" empty :content="alert.kodepos"/>
						</div>
						<div class="form-inline mt-3 mb-3">
							<textarea class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 box-purple" @focus="() => alert.address=''" v-model="courier.detail" rows="3" placeholder="Alamat Lengkap" ></textarea>
							<Alert v-if="alert.address" class="col-12 offset-md-2 col-md-8 font-size-sm-9 text-left pl-0" empty :content="alert.address"/>
						</div>
					</form>
				</div>
			</template>
			<template v-slot:footer>
				<div class="modal-footer justify-content-center">
					<button @click="simpanAlamatPublic()" class="col-10 col-md-3 btn pt-2 pb-2 rounded background-button-template no-box-shadow color-white text-center">
						<i class="fas fa-save font-size-12 mr-3"></i>
						<span class="font-weight-bold text-capitalize">Simpan</span>
					</button>
				</div>
			</template>
		</VModal>
	</div>
</template>

<script>
import VModal from '@/components/VModal';
import Alert from '@/components/Alert';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import $ from 'jquery';
import {id} from 'vuejs-datepicker/dist/locale'
import validator from 'validator'

export default {
	name: 'home',
	components: {
		Alert,	VModal, Datepicker,
	},
	props:{
		shipMethod:{
			type: Object
		},
		pickup:{
			type: Object
		},
		publicData:{
			type: Object
		},
		courier:{
			type: Object
		}
	},
	data () {
		return {
			pickup_error: false,
			indo:id,
			disabledDates:{to: new Date(Date.now() - 8640000)},
			takeMethod: false,
			logisticMethod: false,
			ismember: true,
			listShipMethod: [
			// {id: 0, ship:'Diambil ke Mobile Counter', img:'assets/icon/pick-up.svg'},
			{id: 1, ship:'Jasa Pengiriman', img:'assets/icon/jasa-logistik.svg'}
			],
			isLogistic: false,
			paramOngkir:{
				origin_id : '',
				origin_type : 'subdistrict',
				destination_id : '',
				destination_type : 'subdistrict',
				weight : '',
				courier : ''
			},
			insert: {
				name: '',
				receipt_name: '',
				phonenumber: '',
				as: '1',
				detail: '',
				zipcode: '',
				province_id: '',
				city_id: '',
				district_id: '',
			},
			alert : {
				name: '',
				label: '',
				phonenumber:'',
				prov : '',
				city : '',
				district : '',
				kodepos : '',
				address : '',
			},
			showMoreAddress: false,
		}
	},
	computed:{
		...mapGetters('auth', ['isAuth']),
		...mapState('cart', ['step', 'cartOne', 'courServiceList', 'courSelected', 'registerItem']),
		...mapState('stockist', ['stockistOne']),
		...mapState('address', ['listAdress', 'selectedAddress', 'provinces', 'city', 'districts']),

		weightTotal() {
			var weight = 0
			this.cartOne.products.forEach(el => {
				weight += parseInt(el.product_weight) * el.quantity
			});
			if (!this.isAuth) {
				weight += parseInt(this.registerItem.weight)
			}
			return weight;
		},
		weightCour(){
			var weight = 0
			this.cartOne.products.forEach(el => {
				weight += parseInt(el.product_weight) * el.quantity
			});
			if (!this.isAuth) {
				weight += this.registerItem.weight
			}
			if(weight >= 1000){
				return Math.ceil(weight / 1000)
			} else {
				return 1
			}
		},
		priceTotal() {
			var price = 0
			this.cartOne.products.forEach(el => {
				price += parseInt(el.product_price) * parseInt(el.quantity)
			});
			if (!this.isAuth) {
				price += this.registerItem.price_total
			}
			return price;
		},
		addressMember(){
			if (Array.isArray(this.listAdress)) {
				let address = [...this.listAdress]
				if(this.showMoreAddress){
					return address.sort((a, b) => 
						b.address_is_default - a.address_is_default
						);
				} else {
					return address.filter((el)=> el.address_is_default == 1 )
				}
			} else {
				return []
			}
		}
	},
	methods: {
		...mapMutations('cart' , ['step_up', 'step_down', 'selectCourier', 'resetCourier', 'resetCourServiceList', 'defineCourServiceList']),
		...mapActions('address', ['getAddressList', 'selectAddress', 'getProvinces', 'getCity', 'getDistrict', 'submit']),
		...mapActions('cart', ['getOngkir', 'getRegisterItem']),

		changeProvince() {
			this.getCity(this.insert.province_id) 
			this.alert.province_id=''
			this.insert.city_id=''
			this.insert.district_id=''
			this.insert.zipcode=''
		},
		changeCities() {
			this.getDistrict(this.insert.city_id)
			this.alert.city_id=''
			this.insert.district_id=''
			this.insert.zipcode=''
		},
		changeDistrict() {
			this.insert.zipcode = this.insert.district_id.postal_code
		},
		publicChangeDistrict() {
			this.courier.kodepos = this.courier.district.postal_code
		},
		nextPickup(){
			if(this.pickup.date) {
				this.pickup_error = false;
				this.step_up();
			} else {
				this.pickup_error = true;
			}
		},
		customFormatter(date) {
			return moment(date).format('Do MMMM YYYY');
		},
		chooseAddress(code) {
			this.showMoreAddress = false;
			this.selectAddress(code).then(()=>{
				if(this.isAuth) {
					this.paramOngkir.destination_id = this.selectedAddress.address_district_id
				}
			})
			this.isLogistic = false
		},
		addAlamat() {
			this.getProvinces()
			this.$refs.modalAddAlamat.modalShow()
		},
		publicChangeProvince(id) {
			this.getCity(id);
			this.insert.city_id = ''
			this.insert.district_id = ''
			this.insert.zipcode = ''
			this.courier.city = ''
			this.courier.district = ''
			this.courier.kodepos = ''
		},
		publicChangeCity(id) {
			this.getDistrict(id);
			this.insert.district_id = ''
			this.courier.district = ''
			this.courier.kodepos =''
		},
		simpan() {
			if (!this.insert.receipt_name) {
				this.alert.name = 'Nama Penerima belum anda isi'
			} else {
				this.alert.name = ''
			}
			if (!this.insert.name) {
				this.alert.label = 'Label Alamat belum anda isi'
			} else {
				this.alert.label = ''
			}
			if (!this.insert.phonenumber) {
				this.alert.phonenumber = 'Nomor Telepon belum anda isi'
			} else if (!validator.isLength(this.insert.phonenumber , {min:10 , max:15})) {
				this.alert.phonenumber = 'Nomor Telepon tidak valid'
			} else {
				this.alert.phonenumber = ''
			}
			if (!this.insert.province_id) {
				this.alert.prov = 'Provinsi belum anda isi'
			} else {
				this.alert.prov = ''
			}
			if (!this.insert.city_id) {
				this.alert.city = 'Kota belum anda isi'
			} else {
				this.alert.city = ''
			}
			if (!this.insert.district_id) {
				this.alert.district = 'Kecamatan belum anda isi'
			} else {
				this.alert.district = ''
			}
			// if (!this.insert.zipcode) {
			// 	this.alert.kodepos = 'Kode Pos belum anda isi'
			// } else
			if (this.insert.zipcode && this.insert.zipcode.length != 5) {
				this.alert.kodepos = 'Kode Pos tidak sesuai format'
			} else {
				this.alert.kodepos = ''
			}
			if (!this.insert.detail) {
				this.alert.address = 'Alamat belum anda isi'
			} else if (this.insert.detail.length < 5) {
				this.alert.address = 'Alamat minimal 5 karakter'
			} else {
				this.alert.address = ''
			}
			if (!this.alert.name && !this.alert.label && !this.alert.phonenumber && !this.alert.prov && !this.alert.city && !this.alert.district && !this.alert.kodepos && !this.alert.address) {
				this.paramOngkir.destination_id = this.insert.district_id.subdistrict_id
				this.insert.district_id = this.insert.district_id.subdistrict_id
				this.submit(this.insert)
				this.$refs.modalAddAlamat.modalHide()
				this.insert = {
					name: '',
					receipt_name: '',
					phonenumber: '',
					as: '1',
					detail: '',
					zipcode: '',
					province_id: '',
					city_id: '',
					district_id: '',
				}
				this.showMoreAddress = false
			}
		},
		simpanAlamatPublic(){
			if (!this.courier.name) {
				this.alert.name = 'Nama Penerima belum anda isi'
			}
			if (!this.courier.phone) {
				this.alert.phonenumber = 'Nomor Telepon belum anda isi'
			} else if(!validator.isLength(this.courier.phone , {min:10 , max:15})){
				this.alert.phonenumber = 'Nomor Handphone tidak valid'
			} else {
				this.alert.phonenumber = ''
			}
			if (!this.courier.prov) {
				this.alert.prov = 'Provinsi belum anda isi'
			} else {
				this.alert.prov = ''
			}
			if (!this.courier.city) {
				this.alert.city = 'Kota belum anda isi'
			} else {
				this.alert.city = ''
			}
			if (!this.courier.district) {
				this.alert.district = 'Kecamatan belum anda isi'
			} else {
				this.alert.district = ''
			}
			// if (!this.courier.kodepos) {
			// 	this.alert.kodepos = 'Kode Pos belum anda isi'
			// } else 
			if (this.courier.kodepos && this.courier.kodepos.length != 5) {
				this.alert.kodepos = 'Kode Pos tidak sesuai format'
			} else {
				this.alert.kodepos = ''
			}
			if (!this.courier.detail) {
				this.alert.address = 'Alamat belum anda isi'
			} else if (this.courier.detail.length < 5) {
				this.alert.address = 'Alamat minimal 5 karakter'
			} else {
				this.alert.address = ''
			}
			if (!this.alert.name && !this.alert.phonenumber && !this.alert.prov && !this.alert.city && !this.alert.district && !this.alert.kodepos && !this.alert.address) {
				this.courier.status = true
				this.paramOngkir.destination_id = this.courier.district.subdistrict_id
				this.$refs.modalAlamatPublic.modalHide()
			}
		},
		changeCourier(cour) {
			this.isLogistic = true
			this.selectCourier(cour)
			var pd = $('.pay-detail').offset().top
			pd -= 100
			$('html').scrollTop(pd)
		},
		changeShipping(val, code) {
			this.shipMethod.name = val;
			this.shipMethod.code = code;
			if(code == 1){
				this.paramOngkir.origin_id = this.stockistOne.stockist_origin_subdistrict_id
				this.paramOngkir.weight = this.weightTotal
				this.paramOngkir.courier = this.stockistOne.stockist_courier
				if (this.isAuth) {
					if (this.selectedAddress) {
						this.paramOngkir.destination_id = this.selectedAddress.address_district_id
					}
				} else {
					if (this.courier.status == true) {
						this.paramOngkir.destination_id = this.courier.district.subdistrict_id
					}
				}
				
			}
			var sm = $('.shipping-method').offset().top
			sm += 280
			$('html').scrollTop(sm)
		},
	},
	created: function () {
		this.shipMethod.name = 'Pilih Metode Pengiriman';
		this.shipMethod.code = '';
		this.paramOngkir.origin_id = this.stockistOne.stockist_origin_subdistrict_id
		this.paramOngkir.courier = this.stockistOne.stockist_courier
		this.getProvinces()
		if(this.isAuth) {
			this.getAddressList()
		} else {
			this.getRegisterItem()
		}
		$('html').scrollTop(0)
	},
	watch: {
		paramOngkir: {
			deep: true,
			handler(val){
				this.resetCourServiceList()
				this.resetCourier()
				if (val.origin_id && val.courier && val.weight && val.destination_id) {
					this.getOngkir(val)
				} else {
					this.defineCourServiceList('error')
				}
			}
		}
	},
	mounted() {
	},
	filters: {
		truncate: function (text, length, suffix) {
			return text.substring(0, length) + suffix;
		},
	}
}
</script>

<style scoped>
.dropdown-item:hover {
	background-color: #7C1CC6;
	color: #ffffff !important;
}
.dropdown-menu .dropdown-item:hover .img-ship {
	filter: brightness(0) invert(1);
}
.dropdown-toggle::after {
	display: none;
}
.active-address {
	border: 2px solid #7C1CC6 !important;
	border-left-width: 10px !important;
}
.logistic {
	min-height: 14rem;
	max-height: 14rem;
	overflow-y: auto;
}
.logistic .checkmark {
	top: 17px;
	height: 15px;
	width: 15px;
	background-color: #ffffff;
	border: 1px solid #7C1CC6;
}
.product-name:hover input ~ .checkmark {
	background-color: #7C1CC6;
}
.logistic .checkmark::after {
	border: none;
}
.address {
	min-height: 18rem;
	max-height: 18rem;
	overflow-y: auto;
}
@media (max-width: 425px) {
	.address {
		min-height: 15rem;
	}
}
</style>